import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { fetchNewCourses } from '../../../actions/course.actions';
import useAction from '../../../utils/useAction';
import { getNewCourses, getNewCoursesStatus } from '../../../reducers/dashboard.selectors';
import { AsyncActionStatus } from '../../../actions/common.actionTypes';
import NewCarousel from '../../../components/Carousel/NewCarousel';
import useRouter from '../../../utils/useRouter';
import { numberOfSlides, routes } from '../../../constants';
import { CourseMindItemSearchResult } from '@kimuno/api-sdk/lib/types/responses/MindItem';
import DashboardMuiCard from '../../cards/MuiCard/DashboardMuiCard';
import { getCourseMuiCardProps } from '../../cards/MuiCard/CourseMuiCard/utils';
import CardSkeleton from '../../Carousel/CardSkeleton';
import { isSchoolSubdomain } from '../../../utils/subdomain';

const CoursesCarousel: React.FC = () => {
  const { t } = useTranslation();
  const { router } = useRouter();
  const fetchNewCoursesAction = useAction(fetchNewCourses);
  const newCourses = useSelector((state) => getNewCourses(state));
  const newCoursesStatus = useSelector((state) => getNewCoursesStatus(state));
  const slides = new Array(numberOfSlides.xl).fill(null);
  const isSchulenUser = isSchoolSubdomain(window.location.hostname);

  useEffect(() => {
    if (isSchulenUser) return;
    fetchNewCoursesAction();
  }, []);

  if (isSchulenUser) return null;
  if (newCourses.length < numberOfSlides.xl) return null;

  return (
    <NewCarousel 
      title={t('New in the course catalog')}
      onShowAll={() => router.push(`/${routes.courseCatalog.root}`)}
    >
      {newCoursesStatus === AsyncActionStatus.READY ? (
        newCourses.map((course: CourseMindItemSearchResult, index: number) => (
          <DashboardMuiCard
            key={index}
            {...getCourseMuiCardProps(course)}
          />
        ))
      ) : slides.map((_, index) => <CardSkeleton key={index} />)}
    </NewCarousel>

  );
};

export default React.memo(CoursesCarousel);
